/**
 * One map so the list, the panel and the history modal cannot disagree
 * about what a status looks like.
 */
export const statusChipClasses = (status: string): string => {
    switch (status) {
        case 'Running':
            return 'text-info bg-info-soft'
        case 'Pending':
            return 'text-safe-700 bg-safe-100'
        case 'Deferred':
            return 'text-suspect-700 bg-suspect-100'
        case 'Failed':
        case 'Panicked':
            return 'text-severe-700 bg-severe-100'
        case 'Completed':
        case 'Cancelled':
        default:
            return 'text-ink-700 bg-ink-100'
    }
}
